export default "__VITE_ASSET__55cfb28c__"